import { useContext, useEffect } from 'react';
import MainContext from "context/MainContext";
import AuthContext from "context/AuthContext";

const Main = ({ children }) => {
  const { mainClass, setMainClass, large } = useContext(MainContext);
  const { user } = useContext(AuthContext);


  useEffect(() => {
    let classes = ""
    if (user) {
      classes = "container-fluid pt-5";
      classes += large ? " large" : " short"
    } else {
      classes = "d-flex align-items-center p4 bg-body-tertiary"
    }

    setMainClass(classes)
  }, [user, setMainClass, large]);


  return (
    <main className={mainClass}>
      {children}
    </main>
  )
}

export default Main